import { openApiInstances } from './openApis';

export const getRemoteSettings = () => openApiInstances.Config.get('/api');
